// extracted by mini-css-extract-plugin
export default {"tupacGrid":"_l-z","tupacHeader":"am-z","tupacHeader2":"bm-z","tupacMenu":"cm-z","tupacMenu2":"dm-z","tupacMain":"em-z","tupacMain2":"fm-z"};